import React from 'react';
import { useSelector } from 'react-redux';
import { ButtonType } from '../../../../../ui/buttonTypes';
import { isCompetitionEnded } from '../../../../../ui/builders/utils';
import BtnComponent from '../../../../ui/buttons/BtnComponent';
import classes from './unidentified.module.css';

const Unidentified = () => {
    const { texts } = useSelector((state) => state.translate);
    const state = useSelector((state) => state.contest);

    return (
        <div className={`${classes.unidentifiedStatus} `}>
            <div className={classes.content}>
                <p className={`${classes.boldText} ${classes.notIdentifiedBoldText}`}>{texts.rightBoldWelcome}</p>
                <p className={classes.welcomeText}>{isCompetitionEnded(state) ? texts.competitionEndedTextForUnidentified : texts.middleTextWelcome}</p>
                <div className={classes.btn}>
                    <BtnComponent type={ButtonType.IDENTIFY} text={texts.btnIdentify} className={classes.identifyButton} />
                </div>
            </div>
        </div>
    );
};

export default Unidentified;

